import {
  LowIncomeSubsidyAmount,
  LowIncomeSubsidyOption,
  LowIncomeSubsidyStatus,
  type UseTranslateTypeStrict,
} from "../@types";
import type { TranslationKey } from "./intlHooks";
import { getYearOrMostRecentValue } from "./constantsHelpers";

type LISStatusLabelsType = {
  [key: string]: {
    [key in LowIncomeSubsidyStatus]: TranslationKey;
  };
};

/**
 * lowIncomeSubsidyStatusLabels define phrase keys for a given year and LIS level.
 */
export const lowIncomeSubsidyStatusLabels: LISStatusLabelsType = {
  "2021": {
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A]: "csr_landing.lis.2021.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN]: "csr_landing.lis.2021.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1B]: "na",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1C]: "na",
    [LowIncomeSubsidyStatus.LIS_LEVEL_2]: "csr_landing.lis.2021.level2",
    [LowIncomeSubsidyStatus.LIS_LEVEL_3]: "csr_landing.lis.level3",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_100]: "csr_landing.lis.2021.level4_100",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_75]: "csr_landing.lis.2021.level4_75",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_50]: "csr_landing.lis.2021.level4_50",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_25]: "csr_landing.lis.2021.level4_25",
    [LowIncomeSubsidyStatus.LIS_NO_HELP]: "csr_landing.lis.no_help",
  },
  "2022": {
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A]: "csr_landing.lis.2022.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN]: "csr_landing.lis.2022.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1B]: "na",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1C]: "na",
    [LowIncomeSubsidyStatus.LIS_LEVEL_2]: "csr_landing.lis.2022.level2",
    [LowIncomeSubsidyStatus.LIS_LEVEL_3]: "csr_landing.lis.level3",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_100]: "csr_landing.lis.2022.level4_100",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_75]: "csr_landing.lis.2022.level4_75",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_50]: "csr_landing.lis.2022.level4_50",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_25]: "csr_landing.lis.2022.level4_25",
    [LowIncomeSubsidyStatus.LIS_NO_HELP]: "csr_landing.lis.no_help",
  },
  "2023": {
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A]: "csr_landing.lis.2023.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN]: "csr_landing.lis.2023.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1B]: "na",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1C]: "csr_landing.lis.2023.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_2]: "csr_landing.lis.2023.level2",
    [LowIncomeSubsidyStatus.LIS_LEVEL_3]: "csr_landing.lis.level3",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_100]: "csr_landing.lis.2023.level4_100",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_75]: "csr_landing.lis.2023.level4_75",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_50]: "csr_landing.lis.2023.level4_50",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_25]: "csr_landing.lis.2023.level4_25",
    [LowIncomeSubsidyStatus.LIS_NO_HELP]: "csr_landing.lis.no_help",
  },
  "2024": {
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A]: "csr_landing.lis.2024.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN]: "csr_landing.lis.2024.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1B]: "na",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1C]: "csr_landing.lis.2024.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_2]: "csr_landing.lis.2024.level2",
    [LowIncomeSubsidyStatus.LIS_LEVEL_3]: "csr_landing.lis.level3",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_100]: "csr_landing.lis.2024.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_75]: "csr_landing.lis.2024.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_50]: "csr_landing.lis.2024.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_25]: "csr_landing.lis.2024.level1A",
    [LowIncomeSubsidyStatus.LIS_NO_HELP]: "csr_landing.lis.no_help",
  },
  "2025": {
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A]: "csr_landing.lis.2025.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN]: "csr_landing.lis.2025.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1B]: "na",
    [LowIncomeSubsidyStatus.LIS_LEVEL_1C]: "csr_landing.lis.2025.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_2]: "csr_landing.lis.2025.level2",
    [LowIncomeSubsidyStatus.LIS_LEVEL_3]: "csr_landing.lis.level3",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_100]: "csr_landing.lis.2025.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_75]: "csr_landing.lis.2025.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_50]: "csr_landing.lis.2025.level1A",
    [LowIncomeSubsidyStatus.LIS_LEVEL_4_25]: "csr_landing.lis.2025.level1A",
    [LowIncomeSubsidyStatus.LIS_NO_HELP]: "csr_landing.lis.no_help",
  },
} as const;

/**
 * Typesafe helper for returning LIS- and year-specific labels
 * @example getLowIncomeSubsidyStatusLabelText({level: lis_level, year, t})
 * @returns the translated label for the given year and LIS level, or the most year's
 * label for the given LIS level, if the year passed in isn't yet defined.
 *
 * If used where you need to conditionally render something, add additional checks,
 * as this helper always returns a string.
 */
export const getLowIncomeSubsidyStatusLabelText = ({
  level,
  t,
  year,
}: {
  level: LowIncomeSubsidyStatus;
  t: UseTranslateTypeStrict;
  year: string | number;
}): string =>
  t(getYearOrMostRecentValue(year, lowIncomeSubsidyStatusLabels)[level]);

export const isLowIncomeSubsidyStatusLabelAvailable = (
  year: string | number,
  level: LowIncomeSubsidyStatus
): boolean => {
  if (lowIncomeSubsidyStatusLabels[`${year}`]) {
    return lowIncomeSubsidyStatusLabels[`${year}`][level] ? true : false;
  } else {
    return false;
  }
};

export const getNewLISCodeFromUserOptions = (
  hideExtraSSHelp: boolean,
  helpType: LowIncomeSubsidyOption | undefined,
  amountOfSSHelp: LowIncomeSubsidyAmount | null
): LowIncomeSubsidyStatus => {
  if (helpType === LowIncomeSubsidyOption.Medicaid) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_1A;
  }
  if (helpType === LowIncomeSubsidyOption.SSI) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN;
  }
  if (helpType === LowIncomeSubsidyOption.MSP) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_1B;
  }
  if (helpType === LowIncomeSubsidyOption.Unsure) {
    return LowIncomeSubsidyStatus.LIS_NO_HELP;
  }
  if (helpType === LowIncomeSubsidyOption.SS) {
    if (hideExtraSSHelp) {
      return LowIncomeSubsidyStatus.LIS_LEVEL_1C;
    }
    if (amountOfSSHelp === LowIncomeSubsidyAmount.HelpNA) {
      return LowIncomeSubsidyStatus.LIS_LEVEL_1C;
    }
    if (amountOfSSHelp === LowIncomeSubsidyAmount.Help0) {
      return LowIncomeSubsidyStatus.LIS_LEVEL_4_100;
    }
    if (amountOfSSHelp === LowIncomeSubsidyAmount.Help25) {
      return LowIncomeSubsidyStatus.LIS_LEVEL_4_75;
    }
    if (amountOfSSHelp === LowIncomeSubsidyAmount.Help50) {
      return LowIncomeSubsidyStatus.LIS_LEVEL_4_50;
    }
    if (amountOfSSHelp === LowIncomeSubsidyAmount.Help75) {
      return LowIncomeSubsidyStatus.LIS_LEVEL_4_25;
    }
    if (amountOfSSHelp === LowIncomeSubsidyAmount.HelpUnsure) {
      return LowIncomeSubsidyStatus.LIS_LEVEL_4_100;
    }
  }
  return LowIncomeSubsidyStatus.LIS_NO_HELP;
};

export const getUserOptionFromLISCode = (
  lis?: LowIncomeSubsidyStatus
): LowIncomeSubsidyOption | undefined => {
  switch (lis) {
    case LowIncomeSubsidyStatus.LIS_LEVEL_1A:
      return LowIncomeSubsidyOption.Medicaid;
    case LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN:
      return LowIncomeSubsidyOption.SSI;
    case LowIncomeSubsidyStatus.LIS_LEVEL_1B:
      return LowIncomeSubsidyOption.MSP;
    case LowIncomeSubsidyStatus.LIS_LEVEL_1C:
      return LowIncomeSubsidyOption.SS;
    case LowIncomeSubsidyStatus.LIS_NO_HELP:
      return LowIncomeSubsidyOption.None;
  }
  return undefined;
};

export const shouldHideExtraSSHelp = (
  mctCurrentPlanYear: number,
  isOpenEnrollmentNextYearOnly: boolean | undefined
) =>
  (mctCurrentPlanYear === 2023 && !!isOpenEnrollmentNextYearOnly) ||
  mctCurrentPlanYear > 2023;

/**
 * Returns true if the LIS level indicates Dual Special Needs Plan -
 * Has both Medicare and Medicaid.
 */
export const isDSNP = (lis: LowIncomeSubsidyStatus | undefined): boolean =>
  !!lis &&
  [
    LowIncomeSubsidyStatus.LIS_LEVEL_1A,
    LowIncomeSubsidyStatus.LIS_LEVEL_2,
    LowIncomeSubsidyStatus.LIS_LEVEL_3,
  ].includes(lis);

/**
 * @param date Should be in the format YYYY-MM-DD
 */
export const getPlanYearForFutureLisStartDate = (date = ""): number | null => {
  const isDateFormat = /\d\d\d\d-\d\d-\d\d/.test(date);
  if (!isDateFormat) {
    return null;
  }
  return +date.slice(0, 4);
};
